import { AvailableModules } from 'generated/featureDefinitions'

export const isModuleRevampEnabled = (moduleSlug: string | undefined): boolean => {
  if (!moduleSlug) return false

  const availableModules: string[] = [
    AvailableModules.projects,
    AvailableModules.trainings,
    AvailableModules.it_management,
    AvailableModules.it_management_v2,
    AvailableModules.ats,
    AvailableModules.review_process,
    AvailableModules.compensations,
    AvailableModules.shift_management,
    AvailableModules.engagement_insights,
    AvailableModules.complaints,
    AvailableModules.space_control,
    AvailableModules.sales,
    AvailableModules.expenses,
    AvailableModules.procurement,
    AvailableModules.time_tracking,
    AvailableModules.timeoff,
    AvailableModules.lms
  ]

  const slugs = moduleSlug.split(',')

  return slugs.some((slug) => availableModules.includes(slug))
}
